import { IDropdownOption, mergeStyleSets } from "@fluentui/react";
import React from "react";

// Optimized styles for dropdown options - moved outside component to prevent recreation
const dropdownOptionStyles = mergeStyleSets({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%"
  },
  userLabel: {
    fontSize: "12px",
    color: "#0078d4",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  },
  systemLabel: {
    fontSize: "12px",
    color: "#107c10",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px"
  }
});

// Constants for better maintainability
const SPECIAL_OPTIONS = new Set(["Custom", "Loading"]);
const SESSION_TYPE_CONFIG = {
  user: { label: "user", className: dropdownOptionStyles.userLabel },
  system: { label: "system", className: dropdownOptionStyles.systemLabel }
} as const;

interface DropdownOptionRenderProps {
  option?: IDropdownOption;
}

export const DropdownOptionRenderer: React.FC<DropdownOptionRenderProps> = React.memo(({ option }) => {
  // Early return for special options
  if (!option?.key || SPECIAL_OPTIONS.has(option.key as string)) {
    return <span>{option?.text}</span>;
  }

  const sessionType = String(option.key).startsWith("user") ? "user" : "system";
  const config = SESSION_TYPE_CONFIG[sessionType];
  const label = option.text ?? "";

  return (
    <div className={dropdownOptionStyles.container}>
      <span>{label}</span>
      <span className={config.className}>{config.label}</span>
    </div>
  );
});

DropdownOptionRenderer.displayName = "DropdownOptionRenderer";
